import React from "react";

const ContactFormHeader = () => <h1>Contact Us</h1>

export default ContactFormHeader;